import {axios} from '@/utils/request'

const api = {
    dakejianList: '/adminapi/zdakejian/dakejianList',
    dakejianApplyMemberList: '/adminapi/zdakejian/applyMemberList',
    dakejianDetail: '/adminapi/zdakejian/dakejianDetail',
    editDakejian: '/adminapi/zdakejian/editDakejian',
    setDakejianAllStatus: '/adminapi/zdakejian/setDakejianAllStatus',
    deleteDakejian: '/adminapi/zdakejian/deleteDakejian',
    deleteDakejianMember: '/adminapi/zdakejian/deleteDakejianMember',

    refreshCert: '/adminapi/zdakejian/shengShenhe',

    applyMemberDetail: '/adminapi/zdakejian/applyMemberDetail',
    applyMemberEdit: '/adminapi/zdakejian/applyMemberEdit',
    applyMemberDelete: '/adminapi/zdakejian/applyMemberDelete',
    dakejianDownloadUrl: '/adminapi/zdakejian/dakejianDownloadUrl',
    getShengShenheUrls: '/adminapi/zdakejian/getShengShenheUrls',
}

export default api

export function getDakejianList(parameter) {
    return axios({
        url: api.dakejianList,
        method: 'get',
        params: parameter
    })
}

export function getApplyMemberList(parameter) {
    return axios({
        url: api.dakejianApplyMemberList,
        method: 'get',
        params: parameter
    })
}

export function setDakejianAllStatus(parameter) {
    return axios({
        url: api.setDakejianAllStatus,
        method: 'post',
        params: parameter
    })
}

export function getDakejianDetail(parameter) {
    return axios({
        url: api.dakejianDetail,
        method: 'get',
        params: parameter
    })
}

export function refreshCert(parameter) {
    return axios({
        url: api.refreshCert,
        method: 'get',
        params: parameter
    })
}

export function getApplyMemberDetail(parameter) {
    return axios({
        url: api.applyMemberDetail,
        method: 'get',
        params: parameter
    })
}

export function editDakejian(parameter) {
    return axios({
        url: api.editDakejian,
        method: 'post',
        data: parameter
    })
}
export function applyMemberEdit(parameter) {
    return axios({
        url: api.applyMemberEdit,
        method: 'post',
        data: parameter
    })
}

export function deleteDakejian(parameter) {
    return axios({
        url: api.deleteDakejian,
        method: 'post',
        data: parameter
    })
}

export function deleteDakejianMember(parameter) {
    return axios({
        url: api.deleteDakejianMember,
        method: 'post',
        data: parameter
    })
}

export function applyMemberDelete(parameter) {
    return axios({
        url: api.applyMemberDelete,
        method: 'post',
        data: parameter
    })
}

export function getDakejianDownloadUrl(parameter) {
    return axios({
        url: api.dakejianDownloadUrl,
        method: 'post',
        data: parameter
    })
}

export function getShengShenheUrls(parameter) {
    return axios({
        url: api.getShengShenheUrls,
        method: 'post',
        data: parameter
    })
}
